export default __webpack_public_path__ + "static/media/9.e3dde4f2.svg";